import { render, staticRenderFns } from "./Pure-white.vue?vue&type=template&id=391affc4"
import script from "./Pure-white.vue?vue&type=script&lang=js"
export * from "./Pure-white.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports